module.exports = __webpack_public_path__ + "img/Sfondo_ATIS.5fd0ccd2.jpg";